/****************************************************************************
* 言語取得関数
****************************************************************************/
function getBrowserLang(){
  const lang = (window.navigator.languages && window.navigator.languages[0]) ||
      window.navigator.language ||
      window.navigator.userLanguage ||
      window.navigator.browserLanguage;

  // 日本語："ja"
  // 英語："en"
  // 英語（アメリカ合衆国）"：en-US"
  // 中国語（繁体字）："zh-TW"
  // 中国語（簡体字）："zh-CN"
  // フランス語："fr"
  // フランス語（カナダ）："fr-CA"
  // フランス語（スイス）："fr-CH"
  // フランス語（フランス）"fr-FR"
  return lang;
}

/****************************************************************************
* 【共通】言語ごとのティザーサイトへのリダイレクト処理
****************************************************************************/
function SwitchRedirectToTeaserSite(){
  const browserLang = getBrowserLang();// ブラウザ言語
  const path = location.pathname.replace(/\/$/, ''); // 末尾の/を削除
  const langURLArray = {jaURL:"https://www.ahkah.jp/"}//日本サイトのURL
  const referrer = document.referrer;// リファラー
  const teaserPath = '/pages/ahkahsignature_chandelier-1';// ティザーサイトのpath
  const teaserUrl = `${location.origin}${teaserPath}`;// ティザーサイトのURL
  const passwordPath = '/password';// パスワードページのpath

  // console.log(`ブラウザ言語：${browserLang}`);
  // console.log(`リファラー${referrer}`);
  // console.log(`パス：${path}`);


  // 日本語サイトから遷移してきた場合、そのままサイトを表示
  if(referrer.indexOf('ahkah.jp') !== -1){
    showBodyContent();
    
  // ブラウザ言語が日本語の場合
  }else if(browserLang == "ja" || browserLang == "ja-JP"){
    let redirectDone = false;//リダイレクト対象のページかどうかのフラグ

    // ティザーにアクセスしたら、リダイレクトせずにそのまま表示
    if(location.href.indexOf(teaserPath) != -1){
      redirectDone = true;
      showBodyContent();
      return;
    }

    /* 商品ページ　下記の要領でリダイレクト
      * https://ahkah-com.myshopify.com/ja/item/ak2059010100/
      * https://ahkah-com.myshopify.com/products/illtest
      * https://www.ahkah.com/products/ak2059010100
      * https://www.ahkah.com/en/item/ak2059010100
      * https://www.ahkah.com/en/item/ak2059010100/
      *  ↓
      * https://www.ahkah.jp/item/AK2059010100.html（日本語サイト：AEC）
    */ 
    //現在のURLから商品ページの形式にマッチする部分を取得
    const shopifyItemUrlMatch = location.href.match(/\/products\/([a-zA-Z0-9\-_]+)(\?.*)?$/);// shopifyの商品ページのURL形式（例: /products/商品ID）
    const wpItemUrlMatch = location.href.match(/\/item\/([^/?#]+)\/?$/);// WordPressの商品ページのURL形式（例: /item/商品ID/）
    let itemUrlMatch = null;// どちらかの形式で商品IDを取得する変数を初期化

    // 現在のページが商品ページであれば、商品IDを取り出す
    if(wpItemUrlMatch){
      itemUrlMatch = wpItemUrlMatch[1];
    }else if(shopifyItemUrlMatch) {
      itemUrlMatch = shopifyItemUrlMatch[1];
    }

    // 日本語ページへリダイレクト(商品コードはAECの形式に合わせて大文字に変換)
    if(itemUrlMatch){
      //console.log(`${langURLArray.jaURL}item/${itemUrlMatch.toUpperCase()}.html`);
      redirectDone = true;
      location.href = `${langURLArray.jaURL}item/${itemUrlMatch.toUpperCase()}.html`;
    }

    
    /* コレクションページ　下記の要領でリダイレクト　
      * https://www.ahkah.com/en/collections/necklaces
      * https://ahkah-com.myshopify.com/en/item/jewelry/necklace/
      * https://www.ahkah.com/en/item/jewelry/necklace/ ※スラッグの文字制限：小文字の英字・数字・アンダーバー
      *  ↓
      * https://www.ahkah.jp/category/NECKLACE/（日本語サイト：AEC）
    */       
    //現在のURLから商品一覧ページの形式にマッチする部分を取得
    const shopifyCollectionUrlMatch = location.href.match(/\/collections\/([^/?#]+)\/?(\?.*)?$/);// Shopifyの商品一覧ページのURL形式（例: /collections/necklaces）
    const wpCollectionUrlMatch = location.href.match(/\/item\/[a-z0-9_]+\/(?:([a-z0-9_]+))?\/?(?:[?#].*)?$/);// WordPressの商品一覧ページのURL形式（例: /item/jewelry/necklace/）
    let collectionUrlMatch = null;// カテゴリを取得する変数

    // 現在のページが商品ページであれば、商品IDを取り出す
    if(wpCollectionUrlMatch){
      collectionUrlMatch = wpCollectionUrlMatch[1];
    }else if(shopifyCollectionUrlMatch) {
      collectionUrlMatch = shopifyCollectionUrlMatch[1];
    }

    // 日本語ページへリダイレクト(商品コードはAECの形式に合わせて大文字に変換)
    if(collectionUrlMatch){
      // console.log(`${langURLArray.jaURL}category/${collectionUrlMatch.toUpperCase()}/`);
      redirectDone = true;
      location.href = `${langURLArray.jaURL}category/${collectionUrlMatch.toUpperCase()}/`;
    }

    /* その他のページ
      * https://www.ahkah.com/en/〇〇
      *  ↓
      * https://www.ahkah.jp/ext/〇〇（日本語サイト：AEC）
    */
    // マップのキーと照らし合わせて末尾が一致するかチェック
    for (const key in AHKAH.ridirectUrlMap) {
      if (location.pathname.endsWith(key)) {
        // console.log(`一致：${langURLArray.jaURL}${AHKAH.ridirectUrlMap[key]}`);
        redirectDone = true;
        location.href = `${langURLArray.jaURL}${AHKAH.ridirectUrlMap[key]}`;
        break;
      }
    }

    // 上記ページに該当しない場合は、日本語サイトのトップページに遷移
    if(!redirectDone){
      // console.log(`日本語サイトのトップに遷移:${langURLArray.jaURL}`)
      location.href = `${langURLArray.jaURL}`;
    }

  }else{
    // 日本語以外ブラウザの場合、そのまま表示
    // console.log(`日本語以外ブラウザ`);
    showBodyContent();
  }
}


/****************************************************************************
* リダイレクトしない場合はサイトを表示
****************************************************************************/
function showBodyContent (){
  document.body.style.opacity = '1';
}

/****************************************************************************
* 実行処理 リダイレクト処理
****************************************************************************/
try {
  SwitchRedirectToTeaserSite();
  // showBodyContent();
} catch (error) {
  document.body.style.opacity = '1';
  console.error(error);
}